import { authFetch, BASE_BACKEND_URL } from '../../auth'
import React, { useState, useEffect, useCallback } from 'react'
import usePagination from '../../layout/usePagination'
import PriceListIndexView from './PriceListIndexView'
import { useNavigate } from 'react-router-dom'
import { buildPriceListApiUrl } from './helpers/priceListUrlHelpers'

const PriceListIndexApp = (props) => {
  const navigate = useNavigate()
  const [perPage] = useState(25)
  const [currentPage, setCurrentPage] = useState(1)
  const [totalPages, setTotalPages] = useState(1)
  const [isFetching, setIsFetching] = useState(true)
  const [data, setData] = useState([])
  const [title, setTitle] = useState('Listas de Precios')
  const [query, setQuery] = useState('')

  const { pagination, setPagination, handlePaginationClick } = usePagination({
    per_page: 25,
    current_page: 1,
    total_pages: 1
  })

  useEffect(() => {
    fetchDataFromServer(query, currentPage)
  }, [])

  const fetchDataFromServer = useCallback(
    (query, page) => {
      setIsFetching(true)
      const params = new URLSearchParams({
        page,
        per_page: perPage
      })
      if (query) params.set('q', query)

      authFetch(`${buildPriceListApiUrl(BASE_BACKEND_URL, 'price_lists')}?${params.toString()}`, {
        method: 'GET',
      })
        .then((response) => {
          if (response.status === 401) {
            navigate('/')
          }
          return response.json()
        })
        .then((data) => {
          setData(data['table'])
          setIsFetching(false)
          setTotalPages(Math.ceil(data['count'] / perPage))
          setTitle(query ? `Resultados de la búsqueda: ${query}` : 'Listas de Precios')
        })
        .catch((e) => console.log(e))
    },
    [perPage]
  )

  const handleSearchUpdate = (newQuery) => {
    setQuery(newQuery)
    fetchDataFromServer(newQuery, currentPage)
  }

  return (
    <PriceListIndexView
      data={data}
      isFetching={isFetching}
      title={title}
      query={query}
      total_pages={totalPages}
      onSearchUpdate={handleSearchUpdate}
      current_page={currentPage}
      handlePaginationClick={handlePaginationClick}
      fetchDataFromServer={fetchDataFromServer}
    />
  )
}

export default PriceListIndexApp
